import useFeatureFlags from 'hooks/useFeatureFlags'

export const ADD_MEDICATION_FACELIFT_FLAG = 'emar_add_medication_facelift'

/**
 * Whether adding a medication opens the facelift page instead of the legacy
 * modal. The flag reads as off while flags load, so callers must also gate on
 * `isLoading` (docs/feature-flags-and-async-state.md).
 *
 * The second-signature flag is meant to force the facelift on too, but isn't
 * read here yet: until the page can save, that would send those homes to a
 * page they can't finish.
 */
export const useAddMedicationFacelift = () => {
  const { data: flags, isLoading } = useFeatureFlags({
    flagNames: [ADD_MEDICATION_FACELIFT_FLAG]
  })

  return {
    isEnabled: flags[ADD_MEDICATION_FACELIFT_FLAG].enabled,
    isLoading
  }
}
